import { render, staticRenderFns } from "./AddAdvertCampaignModal.vue?vue&type=template&id=7770c20e&"
import script from "./AddAdvertCampaignModal.vue?vue&type=script&lang=ts&"
export * from "./AddAdvertCampaignModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddAdvertCampaignModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports